import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { Grid, IconButton } from '@chakra-ui/react';
import { Svg } from '../../base';
import { JsFieldName, JsFieldInspector } from '../../jsFormBase';
import { InputNumber } from '../../inputs';
import { JsFormConfigContext } from '../../../contexts';
/**
 * Component renders "/schemas/jsf-number-lock" or "/schemas/jsf-float-lock" field of JsonSchema.
 * @param props : field props come from JsonSchema.
 * Value of props.formData is TFormData.
 */
const NumberLockJsFieldFC = (props) => {
    const { isInspector } = useContext(JsFormConfigContext) ?? {};
    const formData = props.formData;
    const handleChangeValue = (value) => {
        const newFormData = { ...formData, value: value ?? null };
        props.onChange(newFormData);
    };
    const handleChangeLock = (locked) => {
        const newFormData = { ...formData, locked };
        props.onChange(newFormData);
    };
    return (_jsx(JsFieldInspector, { isActive: isInspector, fieldCode: props.name, fieldType: props.uiSchema?.['ui:field']?.toString() ?? '', valueType: ['object'], children: _jsxs(Grid, { "data-testid": "NumberLockJsField-test", "data-name": props.name, gridTemplateColumns: "minmax(0, 180px) 1fr 24px", alignItems: "center", gap: "4px", children: [_jsx(JsFieldName, { name: props.schema.title }), _jsx(InputNumber, { size: "xs", variant: "outline", isOnChangeOnlyOnBlur: true, min: props.schema.minimum, max: props.schema.maximum, exclusiveMin: props.schema.exclusiveMinimum, exclusiveMax: props.schema.exclusiveMaximum, value: formData.value ?? undefined, isFloat: props.isFloat, disabled: props.schema.readOnly, rightElement: props.schema.$comment ? _jsx(_Fragment, { children: props.schema.$comment }) : undefined, onChange: (value) => handleChangeValue(value) }), _jsx(IconButton, { size: "smSquare", "aria-label": "", variant: "ghost", isDisabled: props.schema.readOnly, icon: _jsx(Svg, { size: "s12", name: formData.locked ? 'Locked' : 'Unlocked' }), onClick: () => handleChangeLock(!formData.locked) })] }) }));
};
export const NumberLockJsField = NumberLockJsFieldFC;
//# sourceMappingURL=NumberLockJsField.js.map